import { getConfiguration } from "../../utils/configuration";

const blogBanner = document.getElementById("blog-promo");

if (blogBanner !== null) {
	blogBanner.addEventListener("click", () => {
		dataLayer.push({
			event: "stats_blog_banner_click",
			language_code: getConfiguration().languageCode,
		});
	});
}

export {};
